// extracted by mini-css-extract-plugin
export default {"item":"Item_item__ojm1f","item__imagem":"Item_item__imagem__EpAK5","item__descricao":"Item_item__descricao__df7Is","item__titulo":"Item_item__titulo__Vi10z"};